var React = require('react');

function SliderArrowRightWhite (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 21L80 21","stroke":"white","strokeWidth":"1.4","key":0}),React.createElement("path",{"d":"M58.5 1L80 21L58.5 41","stroke":"white","strokeWidth":"1.4","key":1})]);
}

SliderArrowRightWhite.defaultProps = {"width":"82","height":"42","viewBox":"0 0 82 42","fill":"none"};

module.exports = SliderArrowRightWhite;

SliderArrowRightWhite.default = SliderArrowRightWhite;
